import { colors } from "goi_common";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
}

const LargeGrayButton = ({ children }: Props) => {
  return (
    <button
      css={{
        borderRadius: "10px",
        height: "100px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: colors.gray200,
        color: colors.gray900,
        width: "100%",
      }}
      className="subtitle_18_b"
    >
      {children}
    </button>
  );
};

export default LargeGrayButton;
